// The browser's own bars (meta theme-color) take the colour of the page's TOP
// surface — the hero panel of an app page, the sign-in screen, else the canvas —
// so the status bar above a light header is light and above Orca AI is dark.
// It only tints the browser chrome; the page's background plane does the rest.
const opaque = (c: string) => !!c && c !== 'transparent' && !/rgba\([^)]*,\s*0\)$/.test(c);

export function syncChromeColor() {
  if (typeof document === 'undefined') return;
  requestAnimationFrame(() => {
    const top = document.querySelector<HTMLElement>('.auth-page') ?? document.querySelector<HTMLElement>('.app-shell .panel');
    let color = top ? getComputedStyle(top).backgroundColor : '';
    if (!opaque(color)) color = getComputedStyle(document.documentElement).backgroundColor;
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta && opaque(color) && meta.getAttribute('content') !== color) meta.setAttribute('content', color);
  });
}
